import { useUpdateTestMutation, useUploadTestReportMutation } from 'app/services/tools';
import { ToolTest } from 'app/types/tool';
import ToolTestForm from './Form';
import { useState } from 'react';

const EditToolTest = ({ toolTest }: { toolTest: ToolTest }) => {
  const [ update, testMeta ] = useUpdateTestMutation();
  const [ uploadReport, fileMeta ] = useUploadTestReportMutation();

  const [ meta, setMeta ] = useState<any>({ isSuccess: false, data: {} });

  const handleSubmit = async (values: any) => {
    if (values.ReportFile && values.ReportFile && toolTest) {

      const fileList = values.ReportFile as any[] | undefined;
      const first = fileList?.[0];

      if (toolTest?.Id && first && first.status !== 'done' && first.status !== 'error') {
        await uploadReport({ testId: toolTest.Id, file: first.originFileObj }).unwrap();
      }
    }

    const requestBody = {
      Id: toolTest.Id,
      RemoveReport: values.ReportFile && values.ReportFile.length === 0,
      ...values
    };

    await update(requestBody).unwrap();

    setMeta({ isSuccess: true, data: { Id: toolTest.Id } });
  };

  return <ToolTestForm
    handleSubmit={handleSubmit}
    toolTest={toolTest}
    meta={{
      isSuccess: meta.isSuccess,
      isLoading: testMeta.isLoading || fileMeta.isLoading,
      isError: testMeta.isError || fileMeta.isError,
      data: meta.data
    }}
  />;
};

export default EditToolTest;